import { render, staticRenderFns } from "./PagePreview.vue?vue&type=template&id=181574ce"
import script from "./PagePreview.vue?vue&type=script&lang=js"
export * from "./PagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports